import styles from './Contact.module.css';

function Contact() {
    return (
        <div className="mx-lg-5 mx-2 w-100">
            <div className="mx-4">
                <span className="section_label text-shadow-active">CONTACT</span>
            </div>
            <div className={ styles.contactContainer + " mt-5 mx-auto mx-lg-5 d-flex" }>
                <div className="m-auto">
                    <div className="my-3">
                        <img src="/assets/images/aboutus/github.png" alt="Temp 1"/>
                        <span className={ styles.contactLabel + " mx-3" }>github.com/v-lt</span>
                    </div>
                    <div className="my-3">
                        <img src="/assets/images/aboutus/google.png" alt="Temp 2"/>
                        <span className={ styles.contactLabel + " mx-3" }>VOLTAIREUYCOQUE@GMAIL.COM</span>
                    </div>
                    <div className="my-3 d-flex align-items-center">
                        <img src="/assets/images/aboutus/phone.png" alt="Phone Icon" />
                        <div className="d-flex flex-column flex-md-row ms-3 gap-2">
                            <span className={styles.contactLabel}>0402-109-899 (AU), </span>
                            <span className={styles.contactLabel}>0906-556-0972 (PH)</span>
                        </div>
                    </div>

                    <div className="my-3">
                        <img src="/assets/images/aboutus/telegram.png" alt="Temp 3"/>
                        <span className={ styles.contactLabel + " mx-3"} >+63 906 556 0972</span>
                    </div>
                    
                    <a href="./assets/resume/RESUME.docx" download="Volt's Resume (docx).docx" className={ styles.contactATag }>
                        <div className="my-3">
                            <img src="/assets/images/aboutus/save-file.png" alt="Temp 4" className={ styles.contactIcon }/>
                            <span className={ styles.contactLabel + " mx-3"} >Resume (.docx)</span>
                        </div>
                    </a>
                    
                    <a href="./assets/resume/RESUME.pdf" download="Volt's Resume (PDF).pdf" className={ styles.contactATag }>
                        <div className="my-3">
                            <img src="/assets/images/aboutus/save-file.png" alt="Temp 4" className={ styles.contactIcon }/>
                            <span className={ styles.contactLabel + " mx-3"} >Resume (PDF)</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Contact;